export default {
  brand_name: 'USFans Spreadsheet',
  nav_spreadsheet: 'Tableur',
  nav_guides: 'Guides',
  nav_reviews: 'Avis',
  nav_shipping: 'Livraison',
  nav_safety: 'Sécurité',
  nav_faq: 'FAQ',
  nav_mainWebsite: 'Site principal',
  nav_home: 'Accueil',
  nav_shoppingGuide: 'Guide d’achat',
  nav_browseCategories: 'Parcourir les catégories',
  read_more: 'Lire la suite',
};